import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/storybook-components';
import {Tooltip} from '@learningblocks/storybook-components';
import {ErrorLimitExceeded} from './ErrorLimitExceeded';
import {ErrorModalWindow} from './ErrorModalWindow';
import {TOTAL_LEVELS, LEVEL_LIST, LEVELS} from './constants';
import './style.scss';

/**
 * ErrorCountBlock.
 *  - Display the number of incorrect attempts and maximum incorrects can be.
 */
export function ErrorCountBlock(props) {
  let {incorrects, maxIncorrects} = props;
  const [stepSize] = useState(maxIncorrects / TOTAL_LEVELS);
  const [attributes, setErrorAttributes] = useState(LEVEL_LIST[LEVELS.LOW]);

  useEffect(() => {
    let level = LEVELS.LOW;
    if (incorrects < stepSize) {
      level = LEVELS.LOW;
    } else if (incorrects <= 2 * stepSize) {
      level = LEVELS.MEDIUM;
    } else {
      level = LEVELS.HIGH;
    }
    setErrorAttributes(LEVEL_LIST[level]);
  }, [props.incorrects]);

  const renderErrorLimitExceedModal = () => {
    if (incorrects >= maxIncorrects) {
      return (
        <ErrorModalWindow
          isModalOpen={true}
          modalTitle='Error Limit Exceeded'
          className='Modal sm'>
          <ErrorLimitExceeded />
        </ErrorModalWindow>
      );
    } else {
      return null;
    }
  };

  const getTooltipText = () => {
    let attemptsLeft = maxIncorrects - incorrects;
    return `${attemptsLeft} of ${maxIncorrects} Attempts left`;
  };

  return (
    <Tooltip title={getTooltipText()}>
      <>
        <div className={`error-bar ${attributes.className}`}>
          <Image src={attributes.image} alt={`count-${attributes.className}`} />
          <span>{incorrects}</span>
          <span>/</span>
          <span>{maxIncorrects}</span>
          <span>mistakes</span>
        </div>
        {renderErrorLimitExceedModal()}
      </>
    </Tooltip>
  );
}

ErrorCountBlock.propTypes = {
  /**
   * Number repersenting the current incorrects
   */
  incorrects: PropTypes.number.isRequired,
  /**
   * Number repersenting the maximun of Incorrects can be
   */
  maxIncorrects: PropTypes.number.isRequired,
};

ErrorCountBlock.defaultProps = {
  incorrects: 0,
};
